/* A closed accordion never plays media.
   Every accordion is a <details>. When one closes, pause any player inside it: a collapsed panel
   must not keep playing — at best it burns bandwidth for nothing, at worst its audio comes from a
   panel nobody can see. Universal by construction: no per-section opt-in, no class list to maintain.
   ONE delegated listener in the CAPTURE phase, because `toggle` does not bubble. Each panel is
   queried at toggle time, since deferred media is not in the DOM until first play.
   Closing only ever pauses; it never plays. Reopening leaves the video paused at its position. */

(function () {
  /* Pause every player inside one closed panel. Descendants only, so sibling accordions and the
     rest of the page are untouched; a nested accordion's media is inside, and pausing it is right. */
  function pauseMediaIn(root) {
    /* deferred-media owns the correct pause path for both <video> and YouTube/Vimeo iframes
       (postMessage) and resets its own play/pause hint — reuse it rather than duplicating it. */
    for (const media of root.querySelectorAll('deferred-media')) {
      if (typeof media.pauseMedia === 'function') media.pauseMedia();
    }

    /* Fallback for a raw <video> that no deferred-media wraps (e.g. an app block). */
    for (const video of root.querySelectorAll('video')) {
      if (!video.closest('deferred-media')) video.pause();
    }
  }

  function handleToggle(event) {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement)) return;
    /* Opening is the user's call — only a close pauses. */
    if (details.open) return;

    pauseMediaIn(details);
  }

  /* Bind once per page (guards against a duplicate tag). */
  if (document.documentElement.dataset.actevnaAccordionMediaReady) return;
  document.documentElement.dataset.actevnaAccordionMediaReady = 'true';

  document.addEventListener('toggle', handleToggle, true);
})();
